import I18n from 'I18n';
import { WarningIcon } from 'foundations-assets';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { FiltersDisplay } from 'customer-data-filters-ui/public/components';
// @ts-expect-error untyped import
import { useExpressionField, useSourceMeta } from '../SourceMeta';
import { Text } from 'foundations-components/components/Text';
import styled from 'styled-components';
import { View } from 'foundations-components/transitional/components/View';
import { useExpressionFieldFilterStrategy } from '../../strategies/use-expression-field-strategy';
import { transformToFilterBranch } from '../../../../utils/filter-utils';
import { hasObjectTypeId } from '../../../../utils/source-utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledSpanContainer = styled.div.withConfig({
  displayName: "ExpressionFieldFilterDisplayLabel__StyledSpanContainer",
  componentId: "sc-78ty5r-0"
})(["display:block;font-weight:600;margin-bottom:-4px;"]);
const ExpressionFieldOperatorDisplayView = ({
  filter,
  expressionField
}) => {
  const sourceMeta = useSourceMeta();
  const strategy = useExpressionFieldFilterStrategy({
    source: sourceMeta,
    expressionField
  });

  // Check if operation is null/undefined
  const hasOperation = filter.filter && filter.filter.get('operation');
  if (!hasOperation) {
    return null;
  }
  const filtersDisplayValue = transformToFilterBranch(filter, expressionField.alias);
  if (!strategy || !filtersDisplayValue) {
    return /*#__PURE__*/_jsx(Text, {
      as: "h6",
      children: /*#__PURE__*/_jsx("strong", {
        children: expressionField.label
      })
    });
  }
  const baseFilterFamily = hasObjectTypeId(sourceMeta) ? sourceMeta.objectTypeId : sourceMeta.dataSourceId;
  return /*#__PURE__*/_jsx(FiltersDisplay, {
    baseFilterFamily: baseFilterFamily,
    strategy: strategy,
    value: filtersDisplayValue
  });
};
export const ExpressionFieldFilterDisplayLabel = ({
  filter,
  errorTooltipMessage
}) => {
  const {
    field
  } = filter;
  const expressionField = useExpressionField(field.name);
  // Check if operation is null/undefined
  const hasOperation = filter.filter && filter.filter.get('operation');
  if (!expressionField) {
    return null;
  }
  const content = hasOperation ? /*#__PURE__*/_jsx(ExpressionFieldOperatorDisplayView, {
    filter: filter,
    expressionField: expressionField
  }) : /*#__PURE__*/_jsx(Text, {
    as: "strong",
    children: expressionField.label
  });
  const isValid = !errorTooltipMessage;
  return /*#__PURE__*/_jsxs("div", {
    "data-test-id": "expression-field-filter-display-label",
    children: [/*#__PURE__*/_jsx(StyledSpanContainer, {
      children: /*#__PURE__*/_jsxs(Text, {
        color: !isValid ? 'text-alert-default' : 'text-core-default',
        children: [I18n.text('reporting-snowflake.filter-editor.expression-field.label'), !isValid && /*#__PURE__*/_jsx(View, {
          as: "span",
          marginInlineStart: "100",
          children: /*#__PURE__*/_jsx(WarningIcon, {
            alignWithText: true
          })
        })]
      })
    }), isValid ? content : /*#__PURE__*/_jsx(Tooltip, {
      title: errorTooltipMessage,
      children: /*#__PURE__*/_jsx(Text, {
        color: "text-alert-default",
        children: content
      })
    })]
  });
};